// ── Hero logo scroll-morph animation (runs FIRST — must not depend on later code) ──
// Large white logo centered over the homepage video, morphs into the header logo
// on scroll. If this fails to run, Arc/Chrome/Safari show a totally different nav
// (small header logo only, no hero mark). Keep this isolated + retried.
(function() {
  var started = false;

  function init() {
    if (started || document.querySelector('.oc-hero-logo')) {
      started = true;
      return true;
    }
    if (!document.querySelector('.slideshow')) return false;

    var logoBox = document.querySelector('.header__logo');
    var headerLogo = document.querySelector('.header__logo-image--transparent') ||
                     document.querySelector('.header__logo-image');
    if (!headerLogo) return false;

    started = true;
    document.body.classList.add('oc-homepage');

    var overlay = document.createElement('div');
    overlay.className = 'oc-hero-logo';
    overlay.setAttribute('aria-hidden', 'true');
    var img = headerLogo.cloneNode(true);
    img.removeAttribute('class');
    img.removeAttribute('id');
    img.removeAttribute('style');
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    if (img.src) {
      img.src = img.src.split('?')[0] + '?width=1600';
    }
    overlay.appendChild(img);
    document.body.appendChild(overlay);

    var slideshow = document.querySelector('.slideshow');
    var HERO_SCALE_MAX = 3.375;
    var FINAL_SCALE = 1.0;
    var cache = { headerH: 40, headerW: 160, headerViewportY: 40, dx: 0, heroPageY: 0, heroScale: 3.375 };
    var rafId = null;

    function measure() {
      // Prefer the logo link box — absolute transparent img can report 0×0 in some Chromium builds (Arc).
      var measureEl = logoBox || headerLogo;
      var hRect = measureEl.getBoundingClientRect();
      cache.headerH = hRect.height || parseFloat(getComputedStyle(headerLogo).height) || 40;
      cache.headerW = hRect.width || parseFloat(getComputedStyle(headerLogo).width) || 160;
      cache.headerViewportY = hRect.top + cache.headerH / 2;
      cache.dx = (hRect.left + cache.headerW / 2) - (window.innerWidth / 2);

      var maxHeroWidth = window.innerWidth * 0.5625;
      cache.heroScale = Math.min(HERO_SCALE_MAX, maxHeroWidth / Math.max(cache.headerW, 1));

      var sRect = slideshow.getBoundingClientRect();
      var sPageTop = sRect.top + window.scrollY;
      var sPageBottom = sRect.bottom + window.scrollY;
      var visibleHeight = Math.max(1, Math.min(sPageBottom - sPageTop, window.innerHeight));
      cache.heroPageY = sPageTop + visibleHeight / 2;

      overlay.style.setProperty('--oc-header-h', cache.headerH + 'px');
      overlay.style.setProperty('--oc-hero-h', (cache.headerH * cache.heroScale) + 'px');
    }

    function update() {
      rafId = null;
      var scrollY = window.scrollY;
      var naturalDistance = Math.max(1, cache.heroPageY - cache.headerViewportY);
      var morphDistance = naturalDistance * 0.5;
      var morphRaw = Math.min(1, Math.max(0, scrollY / morphDistance));
      var naturalY = cache.heroPageY - scrollY;
      var transitionRaw = Math.min(1, Math.max(0, (morphRaw - 0.6) / 0.4));
      var c1 = 1.70158;
      var c3 = c1 + 1;
      var tMinus1 = transitionRaw - 1;
      var eased = 1 + c3 * tMinus1 * tMinus1 * tMinus1 + c1 * tMinus1 * tMinus1;
      var currentY = naturalY + (cache.headerViewportY - naturalY) * eased;
      var scale = 1 + (FINAL_SCALE / cache.heroScale - 1) * eased;
      var dx = cache.dx * eased;
      var invert = transitionRaw >= 0.95 ? 1 : 0;

      overlay.style.setProperty('--oc-hero-cy', currentY.toFixed(1) + 'px');
      overlay.style.setProperty('--oc-dx', dx.toFixed(1) + 'px');
      overlay.style.setProperty('--oc-dy', '0px');
      overlay.style.setProperty('--oc-scale', scale.toFixed(4));
      overlay.style.setProperty('--oc-invert', invert.toFixed(3));
    }

    function onScroll() {
      if (rafId === null) rafId = requestAnimationFrame(update);
    }

    function onResize() {
      measure();
      update();
    }

    measure();
    update();
    requestAnimationFrame(function() {
      overlay.classList.add('is-ready');
      onResize();
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);
    if (img.complete) onResize();
    else img.addEventListener('load', onResize, { once: true });
    return true;
  }

  function boot() {
    if (init()) return;
    var tries = 0;
    var timer = setInterval(function() {
      tries += 1;
      if (init() || tries > 20) clearInterval(timer);
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', boot, { once: true });
})();

// ── Direct-to-checkout: fully-sequential clear → add → redirect ──────────
// Watches are unique (max quantity 1). If the item is already in the cart
// from a prior session (including after visiting /checkout and coming back),
// /cart/add rejects the submission. We use the JSON endpoints to fully
// serialize the operations: clear → add → navigate to /checkout.
(function() {
  try {
  function attach(form) {
    if (form.dataset.ocCartClearAttached) return;
    form.dataset.ocCartClearAttached = 'true';
    var onSubmit = async function(e) {
      e.preventDefault();
      e.stopImmediatePropagation(); // block the theme's own <product-form> handler from also adding
      e.stopPropagation();
      var submitBtn = form.querySelector('[type="submit"]');
      // Bail if the product is unpurchasable (sold out, on hold, inquire, etc.). This catches
      // Enter-key submits and any other path that bypasses the button's disabled HTML state.
      if (form.querySelector('[data-oc-inquire]')) {
        return;
      }
      if (submitBtn && submitBtn.disabled) {
        return;
      }
      // Disable the submit button during the async flow to prevent double-click. Tag it so the
      // bfcache pageshow handler below knows it's safe to re-enable (vs an on-hold/sold-out
      // button that was disabled by Liquid and must stay disabled).
      if (submitBtn) {
        submitBtn.setAttribute('disabled', 'disabled');
        submitBtn.setAttribute('data-oc-disabled-by-checkout', 'true');
      }
      try {
        // 1. Wipe the existing cart
        await fetch('/cart/clear.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }
        });
        // 2. Add the selected variant
        var formData = new FormData(form);
        var addRes = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' },
          body: formData
        });
        if (!addRes.ok) {
          var body = await addRes.json().catch(function() { return null; });
          throw new Error((body && body.description) || 'Add failed');
        }
        // 3. Remember the product URL so /cart can bounce back here if
        //    the customer hits "Return to cart" from Shopify's checkout.
        try {
          sessionStorage.setItem(
            'oc-last-product-url',
            window.location.pathname + window.location.search
          );
        } catch (e) {}
        // 4. Go to checkout
        window.location.href = '/checkout';
      } catch (err) {
        // Fall back to a native submit so the customer sees Shopify's error
        if (submitBtn) {
          submitBtn.removeAttribute('disabled');
          submitBtn.removeAttribute('data-oc-disabled-by-checkout');
        }
        form.removeEventListener('submit', onSubmit, true);
        form.submit();
      }
    };
    form.addEventListener('submit', onSubmit, true);
  }

  function scan() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  // Re-scan on dynamic DOM updates (section re-rendering, variant swaps)
  var mo = new MutationObserver(scan);
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // When the page is restored from bfcache (browser back/forward), the submit button is still
  // disabled from the previous purchase flow. Only re-enable buttons WE disabled — leave any
  // Liquid-disabled buttons (on-hold, sold-out) alone.
  window.addEventListener('pageshow', function(e) {
    document.querySelectorAll('form[action*="/cart/add"] [type="submit"][data-oc-disabled-by-checkout]').forEach(function(btn) {
      btn.removeAttribute('disabled');
      btn.removeAttribute('data-oc-disabled-by-checkout');
    });
  });
  } catch (e) {}
})();

// js/sections/newsletter-popup.js
try {
var ContactPopup = class extends HTMLElement {
    constructor() {
        super();
        this.triggers = document.querySelectorAll('.contact-trigger');
    }
    connectedCallback() {
      if (this.dataset.ocContactBound) return;
      this.dataset.ocContactBound = 'true';
      document.addEventListener('click', (e) => {
        if (!e.target.closest('.contact-trigger')) return;
        e.preventDefault();
        this.toggleDisplay();
      });
    }

    toggleDisplay() {
        this.classList.toggle('contact-pop-is-active');
    }
    
  };
  if (!window.customElements.get("contact-popup")) {
    window.customElements.define("contact-popup", ContactPopup);
  }
} catch (e) {}

// ── Hide hero logo when search panel opens ────────────────────────────────
// CSS :has() covers modern browsers; this MutationObserver covers older
// iOS Safari (< 15.4) that lacks :has() support.
(function() {
  function watchSearch() {
    var headerSearch = document.querySelector('header-search');
    if (!headerSearch) return;
    new MutationObserver(function() {
      document.body.classList.toggle('search-open', headerSearch.hasAttribute('open'));
    }).observe(headerSearch, { attributes: true, attributeFilter: ['open'] });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchSearch);
  } else {
    watchSearch();
  }
})();

// ── Timed "Questions About This Watch?" popup — product pages only ─────────
(function() {
  var DELAY_MS = 15000;
  var SESSION_KEY = 'oc-watch-form-shown';

  if (window.Shopify && window.Shopify.designMode) return;
  if (!window.location.pathname.startsWith('/products/')) return;
  if (sessionStorage.getItem(SESSION_KEY)) return;

  setTimeout(function() {
    var btn = document.querySelector('[aria-controls="modal-modal_XM7qHM"]');
    if (btn) {
      btn.click();
      sessionStorage.setItem(SESSION_KEY, 'true');
    }
  }, DELAY_MS);
})();

// ── Mobile product page: move buy/enquiry buttons under price; sticky footer when scrolled past ──
(function() {
  if (window.Shopify && window.Shopify.designMode) return;
  if (!window.location.pathname.startsWith('/products/')) return;

  var MOBILE_MAX = 700;
  var stickyBar = null;
  var intersectionObs = null;
  var repositioned = false;
  var buyPrevEl = null;
  var movedTrigger = null;
  var paymentTermsPrevEl = null;

  function isMobile() {
    return window.innerWidth < MOBILE_MAX;
  }

  function getEls() {
    return {
      priceItem: document.querySelector('.product-info__block-item[data-block-type="price"]'),
      buyItem:   document.querySelector('.product-info__block-item[data-block-type="buy-buttons"]'),
      modalItem: document.querySelector('.product-info__block-item[data-block-type="modal"]'),
      paymentTermsItem: document.querySelector('.product-info__block-item[data-block-type="payment-terms"]')
    };
  }

  function repositionButtons() {
    if (repositioned) return;
    var els = getEls();
    if (!els.priceItem || !els.buyItem || !els.modalItem) return;

    var triggerBtn = els.modalItem.querySelector('button[aria-controls]');
    if (!triggerBtn) return;

    buyPrevEl = els.buyItem.previousElementSibling;
    paymentTermsPrevEl = els.paymentTermsItem ? els.paymentTermsItem.previousElementSibling : null;

    // Move buy-buttons block item after price
    els.priceItem.after(els.buyItem);

    // Bring the Shop Pay installments line along too, directly after the
    // buttons (replacing the spot where "More payment options" used to be —
    // that toggle is hidden via CSS). Otherwise it's left behind further
    // down the page, after description/badges in natural DOM order.
    var afterBuyItem = els.buyItem;
    if (els.paymentTermsItem) {
      els.buyItem.after(els.paymentTermsItem);
      els.paymentTermsItem.style.marginBlockStart = '8px';
      afterBuyItem = els.paymentTermsItem;
    }

    // Move ONLY the trigger button — leave x-modal in place so Globo stays initialised
    movedTrigger = triggerBtn;
    afterBuyItem.after(movedTrigger);

    // Force exact gaps (0 on the sender side, so only the receiver's
    // margin-block-start applies — otherwise the theme's own default
    // block spacing collapses with ours and wins, since margins collapse
    // to the larger of the two, not the sum).
    els.buyItem.style.marginBlockEnd = '0';
    movedTrigger.style.display = 'block';
    movedTrigger.style.marginBlockStart = els.paymentTermsItem ? '16px' : '8px';
    if (els.paymentTermsItem) els.paymentTermsItem.style.marginBlockEnd = '0';

    repositioned = true;
  }

  function revertButtons() {
    if (!repositioned) return;
    var els = getEls();
    if (!els.buyItem) { repositioned = false; return; }

    // Restore trigger button into the modal block item (before x-modal)
    if (movedTrigger && els.modalItem) {
      var xModal = els.modalItem.querySelector('x-modal');
      if (xModal) {
        els.modalItem.insertBefore(movedTrigger, xModal);
      } else {
        els.modalItem.appendChild(movedTrigger);
      }
      movedTrigger.style.display = '';
      movedTrigger.style.marginBlockStart = '';
    }
    movedTrigger = null;

    // Restore payment-terms to its original position
    if (els.paymentTermsItem) {
      els.paymentTermsItem.style.marginBlockStart = '';
      els.paymentTermsItem.style.marginBlockEnd = '';
      if (paymentTermsPrevEl) paymentTermsPrevEl.after(els.paymentTermsItem);
    }
    paymentTermsPrevEl = null;

    // Restore buy-buttons spacing and position
    els.buyItem.style.marginBlockEnd = '';
    if (buyPrevEl) buyPrevEl.after(els.buyItem);

    repositioned = false;
    buyPrevEl = null;
  }

  function createStickyBar() {
    if (stickyBar) return;
    stickyBar = document.createElement('div');
    stickyBar.className = 'oc-mobile-sticky-cta';
    document.body.appendChild(stickyBar);
  }

  function populateStickyBar() {
    if (!stickyBar) return;
    stickyBar.innerHTML = '';
    var els = getEls();
    if (!els.buyItem) return;

    var buyBtn = els.buyItem.querySelector('button');
    if (buyBtn) stickyBar.appendChild(buyBtn.cloneNode(true));

    if (movedTrigger) {
      // Strip the inline margin-block-start used for in-flow spacing —
      // the sticky bar's own flex `gap` already provides spacing, so
      // without this the two stack (8px gap + inline margin = too far apart).
      var triggerClone = movedTrigger.cloneNode(true);
      triggerClone.style.marginBlockStart = '';
      stickyBar.appendChild(triggerClone);
    }
  }

  function removeStickyBar() {
    if (intersectionObs) { intersectionObs.disconnect(); intersectionObs = null; }
    if (stickyBar) { stickyBar.remove(); stickyBar = null; }
  }

  function setupObserver() {
    if (intersectionObs) intersectionObs.disconnect();
    var els = getEls();
    if (!els.buyItem) return;

    intersectionObs = new IntersectionObserver(function(entries) {
      if (!stickyBar) return;
      var entry = entries[0];
      if (!entry.isIntersecting && entry.boundingClientRect.bottom < 0) {
        populateStickyBar();
        stickyBar.classList.add('is-visible');
      } else {
        stickyBar.classList.remove('is-visible');
      }
    }, { threshold: 0 });

    intersectionObs.observe(els.buyItem);
  }

  function enableMobile() {
    repositionButtons();
    createStickyBar();
    setupObserver();
  }

  function disableMobile() {
    removeStickyBar();
    revertButtons();
  }

  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      if (isMobile()) {
        if (!repositioned) enableMobile();
      } else {
        if (repositioned) disableMobile();
      }
    }, 150);
  });

  function init() {
    if (isMobile()) enableMobile();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ── PDP gallery: prevent adaptive-height from collapsing to 0px ──────────
// Prestige sets max-height from selectedCell.clientHeight on connect/settle/
// resize. WebKit/Safari often reports 0 before layout → max-height: 0px → blank
// gallery. We only intervene when collapsed (or missing a usable height), and
// we avoid fighting the theme on every settle/resize (that causes thrash).
(function() {
  var RETRY_MS = [0, 50, 150, 400];

  function aspectHeight(carousel, img) {
    if (!img || !(carousel.clientWidth > 0)) return 0;
    var nw = img.naturalWidth || 0;
    var nh = img.naturalHeight || 0;
    // Shopify width/height attrs are reliable in Safari before decode.
    if (!(nw > 0 && nh > 0)) {
      nw = parseInt(img.getAttribute('width'), 10) || 0;
      nh = parseInt(img.getAttribute('height'), 10) || 0;
    }
    if (!(nw > 0 && nh > 0)) return 0;
    return Math.round(carousel.clientWidth * (nh / nw));
  }

  function selectedCell(carousel) {
    return carousel.selectedCell ||
      carousel.querySelector('.product-gallery__media.is-initial:not([hidden])') ||
      carousel.querySelector('.product-gallery__media:not([hidden])');
  }

  function parsedMaxHeight(carousel) {
    var mh = carousel.style.maxHeight;
    if (!mh) return null;
    var n = parseFloat(mh);
    return isNaN(n) ? null : n;
  }

  function isCollapsed(carousel) {
    var n = parsedMaxHeight(carousel);
    return n !== null && n < 2;
  }

  function needsRescue(carousel) {
    if (carousel.closest('.product--editorial')) return true;
    if (isCollapsed(carousel)) return true;
    // Theme left no clamp but the box itself is still empty.
    if (carousel.clientHeight < 2 && carousel.querySelector('img')) return true;
    return false;
  }

  function rescue(carousel) {
    if (!carousel || !carousel.hasAttribute('adaptive-height')) return;
    if (carousel.closest('.product--editorial')) {
      if (carousel.style.maxHeight) carousel.style.maxHeight = '';
      return;
    }
    if (!needsRescue(carousel)) return;

    var cell = selectedCell(carousel);
    var img = cell && cell.querySelector('img');
    var h = (cell && cell.clientHeight > 1) ? cell.clientHeight : aspectHeight(carousel, img);

    // Clear collapsed clamp so WebKit can reflow.
    if (isCollapsed(carousel) || carousel.clientHeight < 2) {
      carousel.style.maxHeight = '';
      void carousel.offsetHeight;
    }

    if (!(h > 1)) return;

    // Only write a clamp when horizontally scrollable (carousel mode).
    if (carousel.scrollWidth > carousel.clientWidth + 1) {
      var current = parsedMaxHeight(carousel);
      // Don't thrash if theme/we already have a sane height (±2px).
      if (current !== null && Math.abs(current - h) <= 2) return;
      carousel.style.maxHeight = h + 'px';
    }
  }

  function bind(carousel) {
    if (carousel.dataset.ocAdaptHeightFix) return;
    carousel.dataset.ocAdaptHeightFix = 'true';

    var scheduled = null;
    var run = function() {
      if (scheduled) return;
      scheduled = requestAnimationFrame(function() {
        scheduled = null;
        rescue(carousel);
      });
    };

    // Images: only rescue on load — don't re-clamp healthy carousels.
    carousel.querySelectorAll('img').forEach(function(img) {
      img.addEventListener('load', run, { once: false });
      img.addEventListener('error', run, { once: true });
      if (img.complete) run();
    });

    // Theme often re-writes max-height: 0 on settle/resize — rescue only then.
    carousel.addEventListener('carousel:settle', function() {
      if (needsRescue(carousel)) run();
    });
    window.addEventListener('pageshow', run);
    window.addEventListener('orientationchange', run);

    // Catch collapsed inline style from the theme without looping on our own writes.
    var applying = false;
    new MutationObserver(function() {
      if (applying) return;
      if (!isCollapsed(carousel)) return;
      applying = true;
      rescue(carousel);
      applying = false;
    }).observe(carousel, { attributes: true, attributeFilter: ['style'] });

    RETRY_MS.forEach(function(ms) { setTimeout(run, ms); });
    run();
  }

  function scan() {
    document.querySelectorAll('scroll-carousel.product-gallery__carousel').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();

// ── PDP gallery: rescue hung large image CDN transforms ──────────────────
// Shopify image CDN intermittently never returns for very large ?width=
// requests (2500–3200). Working slides use ~700 via srcset; stuck slides keep
// the native src and stay at naturalWidth=0. Cap + reload selected/nearby imgs.
(function() {
  var MAX_W = 1400;

  function withWidth(url, maxW) {
    if (!url) return url;
    try {
      var u = new URL(url, window.location.origin);
      var current = parseInt(u.searchParams.get('width') || '0', 10);
      if (!current || current > maxW) u.searchParams.set('width', String(maxW));
      return u.href;
    } catch (e) {
      return url;
    }
  }

  function capSrcset(srcset, maxW) {
    if (!srcset) return srcset;
    return srcset.split(',').map(function(part) {
      var bits = part.trim().split(/\s+/);
      if (!bits[0]) return part.trim();
      bits[0] = withWidth(bits[0], maxW);
      var desc = bits[1];
      if (desc && /w$/.test(desc)) {
        var w = parseInt(desc, 10);
        if (w > maxW) return '';
      }
      return bits.join(' ');
    }).filter(Boolean).join(', ');
  }

  function fixImg(img) {
    if (!img || img.dataset.ocSrcCapped === '1') return;
    if (img.naturalWidth > 0) {
      img.dataset.ocSrcCapped = '1';
      return;
    }

    var src = img.getAttribute('src') || '';
    var srcset = img.getAttribute('srcset') || '';
    var needsCap = /\bwidth=([2-9]\d{3}|\d{4,})\b/.test(src + ' ' + srcset);
    if (!needsCap && img.complete) return;

    img.dataset.ocSrcCapped = '1';
    img.setAttribute('loading', 'eager');
    if (srcset) img.setAttribute('srcset', capSrcset(srcset, MAX_W));
    var next = withWidth(img.currentSrc || src, MAX_W);
    if (next) img.setAttribute('src', next);

    // If still hung after settle, force a capped reload once.
    setTimeout(function() {
      if (img.naturalWidth > 0) return;
      var retry = withWidth(img.getAttribute('src') || src, 1200);
      if (retry) img.src = retry;
    }, 1200);
  }

  function fixAround(carousel) {
    if (!carousel) return;
    var cells = carousel.cells || Array.prototype.filter.call(carousel.children, function(c) {
      return !c.hasAttribute('hidden');
    });
    var idx = typeof carousel.selectedIndex === 'number' ? carousel.selectedIndex : 0;
    [idx - 1, idx, idx + 1].forEach(function(i) {
      if (i < 0 || i >= cells.length) return;
      var img = cells[i] && cells[i].querySelector('img');
      if (img) fixImg(img);
    });
  }

  function bind(carousel) {
    if (carousel.dataset.ocImgCdnFix) return;
    carousel.dataset.ocImgCdnFix = 'true';

    // Cap all gallery imgs up front so lazy slides never request 3k transforms.
    carousel.querySelectorAll('img').forEach(fixImg);

    carousel.addEventListener('carousel:change', function() { fixAround(carousel); });
    carousel.addEventListener('carousel:settle', function() { fixAround(carousel); });
    fixAround(carousel);
  }

  function scan() {
    document.querySelectorAll('scroll-carousel.product-gallery__carousel').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();

// ── Style Globo submit button + fix column gap inside watch enquiry modal ──
// Globo injects styles dynamically, beating !important in stylesheets.
// Inline styles set via style.setProperty(..., 'important') win over
// everything — including Globo's JS-injected !important rules.
(function() {
  function applyButtonStyles() {
    var buttons = document.querySelectorAll('.globo-formbuilder button');
    buttons.forEach(function(btn) {
      btn.style.setProperty('background-color', '#c9a96e', 'important');
      btn.style.setProperty('color', '#1a1a1a', 'important');
      btn.style.setProperty('border', 'none', 'important');
      btn.style.setProperty('border-radius', '0', 'important');
      btn.style.setProperty('width', '100%', 'important');
      btn.style.setProperty('padding', '1rem 2.5rem', 'important');
      btn.style.setProperty('font-size', '13px', 'important');
      btn.style.setProperty('letter-spacing', '0.08em', 'important');
      btn.style.setProperty('text-transform', 'uppercase', 'important');
      btn.style.setProperty('cursor', 'pointer', 'important');
    });
  }

  function applyColumnGap() {
    var modal = document.querySelector('#modal-modal_XM7qHM');
    if (!modal) return;
    // Globo uses .block-container as the flex row parent, .layout-2-column on each column
    modal.querySelectorAll('.block-container').forEach(function(container) {
      container.style.setProperty('column-gap', '1.5rem', 'important');
    });
    modal.querySelectorAll('.globo-form-control.layout-2-column').forEach(function(el) {
      el.style.setProperty('flex', '1 1 0', 'important');
      el.style.setProperty('width', 'auto', 'important');
      el.style.setProperty('min-width', '0', 'important');
    });
  }

  function applyAll() {
    applyButtonStyles();
    applyColumnGap();
  }

  function init() {
    applyAll();
    var observer = new MutationObserver(applyAll);
    observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();